import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import { LocationIcon } from "../../../../../../assets/icons/svgicons";
import logo from "../../../../../../assets/logos/golden-logo.png";
import silver from "../../../../../../assets/logos/silver-logo.png";
import Button from "../../../../../common/Button/Button";
import InputFormik from "../../../../../common/Formik/Input/InputFormik";
import Select from "../../../../../common/Formik/Select/Select";
import styles from "../P2pTab/Buy/Buy.module.scss";
import AddAddress from "../../../../../common/Modals/AddAddress/AddAddress";
import RedeemMakePayment from "../../../../../common/Modals/PaymentModals/RedeemMakePayment";
import ErrorText from "../../../../../common/Formik/ErrorText/ErrorText";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import {
  Messages,
  FORMIK_REGEX,
  STATUS_CODE,
} from "../../../../../../utils/constants";
import {
  getSpotPriceAction,
  getTokenBalanceAction,
  getUserInfoAction,
  getShipstationCarriersAction,
  getShipstationRatesAction,
  getUserCoinListAction,
  saveTokeBalance,
} from "../../../../../../features/user/userSlice";
import * as Yup from "yup";
import { validationMessage } from "../../../../../../Helper/helperfunction";
import { formatPrice, toFix } from "../../../../../../utils/utils";
import { allCountries } from "country-region-data";

const assetOptions = [
  {
    label: "Gold STBL",
    icon: logo,
    value: 1,
    symbol: "XAU/USD",
  },
  {
    label: "Silver STBL",
    icon: silver,
    value: 2,
    symbol: "XAG/USD",
  },
];

const Redeem = ({ selectedAsset, activeTab }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showRedeemPayment, setShowRedeemPayment] = useState(false);
  const [spotPrice, setSpotPrice] = useState(null);
  const [address, setAddress] = useState({});
  const [redeemData, setRedeemData] = useState(null);
  const [tokenSymbol, setTokenSymbol] = useState(
    assetOptions.find((opt) => opt.value == selectedAsset?.value) ||
    assetOptions[0]
  );
  const [shippingFee, setShippingFee] = useState(0);
  const [localTokenBalance, setLocalTokenBalance] = useState(0);
  const tokenBalance = useSelector((state) => state?.users?.tokenBalance);
  const [userData, setUserData] = useState();
  const shippingAddressObj = userData?.addressList?.[0];
  const parsedState = shippingAddressObj?.state ? JSON.parse(shippingAddressObj.state) : null;
  const parsedCountry = shippingAddressObj?.country ? JSON.parse(shippingAddressObj.country) : null;

  const [shipList, setShipList] = useState([]);
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [shipstationFee, setShipstationFee] = useState([]);
  const [shippedFee, setShippedFee] = useState([]);
  const [decimalLimit, setDecimalLimit] = useState();

  const isInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized.current && selectedAsset) {
      const selected = assetOptions.find(
        (option) => option.value == selectedAsset.value
      );
      if (selected) {
        setTokenSymbol(selected);
        isInitialized.current = true;
      }
    }
  }, [selectedAsset]);

  useEffect(() => {
    if (activeTab === "redeem") {
      setLocalTokenBalance(0);
    }
  }, [activeTab]);

  const redeemValidationSchema = Yup.object({
    quantity: Yup.string()
      .required(validationMessage("Quantity"))
      .matches(FORMIK_REGEX.WHOLENUMBER, Messages?.NONZERODECIMALVALIDATION)
      .test("checkBalance", "Quantity exceeds token balance!", (val) => {
        if (val > Number(localTokenBalance)) {
          return false;
        }
        return true;
      }),
    shippingAddress: Yup.string()
      .label("Address")
      .required(validationMessage("Address"))
      .min(4),
    price: Yup.number()
      .typeError("Market price is required")
      .required("Temporary service issue. Please try again shortly")
      .min(0.000001, "Price must be greater than 0"),
  });

  const getUserProfile = async () => {
    const response = await dispatch(getUserInfoAction());
    if (response?.data?.data) {
      setUserData(response.data.data);
    }
  };

  const fetchCoinOptions = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        const quantityDecimal = newData.find(
          (coin) => coin.coin_symbol === tokenSymbol?.label
        );
        setDecimalLimit(quantityDecimal?.quantity_decimal);
      }
    } catch (error) {
      console.error("Error fetching coin options:", error);
    }
  };

  const shipStation = async () => {
    try {
      const response = await dispatch(getShipstationCarriersAction());
      if (response.status === 200) {
        const carriers = response.data.data;
        setShipList(carriers);
        const carrierWithMaxBalance = carriers.reduce((maxCarrier, carrier) =>
          carrier.balance > maxCarrier.balance ? carrier : maxCarrier
        );
        setSelectedCarrier(carrierWithMaxBalance);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const shipStationRates = async (toAddress, deliveryAddressLine) => {
    const onRedeemTab = !activeTab || activeTab === "redeem";
    if (!onRedeemTab) return;

    const line =
      deliveryAddressLine !== undefined && deliveryAddressLine !== null
        ? deliveryAddressLine
        : formik.values.shippingAddress;
    if (typeof line !== "string" || line.trim().length === 0) return;

    try {
      const response = await dispatch(
        getShipstationRatesAction({
          carrierCode: selectedCarrier?.code,
          fromPostalCode: 84003,
          toPostalCode: toAddress.postalCode,
          toState: toAddress.state,
          toCity: toAddress.city,
          toCountry: toAddress.country,
          quantity: formik.values.quantity,
        })
      );
      if (response.status === 200) {
        setShipstationFee(response.data.data);
        const groundShipping = response.data.data?.find(
          (item) =>
            item.serviceName === "USPS Priority Mail - Medium Flat Rate Box"
        );

        setShippedFee(groundShipping);
        setShippingFee(response.data.data[0].shipmentCost);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    shipStation();
  }, []);


  // useEffect(() => {
  //   if (selectedCarrier) {
  //     const toAddress = parseShippingAddress(formik.values.shippingAddress);
  //     if (toAddress) {
  //       shipStationRates(toAddress);
  //     }
  //   }
  // }, [selectedCarrier]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: userData?.first_name,
      username: userData?.username,
      email: userData?.email,
      city: shippingAddressObj?.city || "",
      state: parsedState?.isoCode || parsedState?.name || "",
      postalCode: shippingAddressObj?.zip_code || "",
      country: parsedCountry?.sortname || parsedCountry?.name || "",
      phone: userData?.phone || "",
      carrierCode: selectedCarrier?.code,
      serviceCode: shippedFee?.serviceCode,
      tokenId: tokenSymbol?.value,
      quantity: "",
      price: spotPrice,
      totalAmount: Number(shippingFee),
      shippingAddress: shippingAddressObj?.address
        ? (shippingAddressObj.address.includes(shippingAddressObj.city)
          ? shippingAddressObj.address
          : `${shippingAddressObj.address}${shippingAddressObj.address && shippingAddressObj.city ? ", " : ""}${shippingAddressObj.city}`)
        : "",
    },
    validationSchema: redeemValidationSchema,
    onSubmit: async (values) => {
      setRedeemData({ ...values, quantity: Number(values.quantity) });
      setShowRedeemPayment(true);
      setShow(false);
    },

  });

  useEffect(() => {
    const onRedeemTab = !activeTab || activeTab === "redeem";
    if (!onRedeemTab) return;
    if (
      selectedCarrier &&
      formik.values.postalCode &&
      formik.values.state &&
      formik.values.city &&
      formik.values.country
    ) {
      const toAddress = {
        postalCode: formik.values.postalCode,
        state: formik.values.state,
        city: formik.values.city,
        country: formik.values.country,
      };
      shipStationRates(toAddress);
    }
  }, [
    activeTab,
    selectedCarrier,
    formik.values.shippingAddress,
    formik.values.postalCode,
    formik.values.state,
    formik.values.city,
    formik.values.country,
  ]);


  const getBalance = async (data) => {
    try {
      const params = {
        tokenId: tokenSymbol?.value,
      };
      await dispatch(getTokenBalanceAction(params));
    } catch (error) {
      console.log("error", error);
    }
  };

  const getSpotPrice = async () => {
    try {
      const params = {
        symbol: tokenSymbol?.symbol,
      };
      const response = await dispatch(getSpotPriceAction(params));
      if (response.status === STATUS_CODE.successful) {
        setSpotPrice(response?.data?.data?.Ask);
      } else {
        setSpotPrice(null);
      }
    } catch (error) {
      console.log("error", error);
      setSpotPrice(null);
    }
  };

  useEffect(() => {
    getUserProfile();
  }, []);

  useEffect(() => {
    if (!activeTab || activeTab === "redeem") {
      dispatch(saveTokeBalance(0));
      getBalance();
      fetchCoinOptions();
      getSpotPrice();
    }
  }, [tokenSymbol, activeTab]);

  // const handleAddress = (data) => {
  //   const obj = `${data?.shippingaddress}, ${data?.city}, ${data?.state?.name}, ${data?.zipcode}`;
  //   formik.setFieldValue("shippingAddress", obj);
  //   formik.setFieldValue("city", data?.city);

  useEffect(() => {
    if ((!activeTab || activeTab === "redeem") && tokenBalance !== undefined) {
      setLocalTokenBalance(tokenBalance);
    }
  }, [tokenBalance, activeTab]);
  //   formik.setFieldValue("state", data?.state?.name);
  //   formik.setFieldValue("country", data?.country?.name);
  //   formik.setFieldValue("postalCode", data?.zipcode);

  //   const toAddress = {
  //     postalCode: data?.zipcode,
  //     state: data?.state?.name,
  //     city: data?.city,
  //     country: data?.country?.sortname,
  //   };
  //   shipStationRates(toAddress);
  // };

  const handleAddress = (data) => {
    const countryData = allCountries?.find(
      (country) => country[0] === data?.country?.name
    );

    let stateAbbreviation = data?.state?.label;

    if (countryData) {
      const regions = countryData[2];

      const region = regions?.find(
        (region) =>
          region[0] === data?.state?.name || region[1] === data?.state?.name
      );
      if (region) {
        stateAbbreviation = region[1] || region[0];
      } else {
      }
    } else {
      console.log(
        "No matching country data found for country:",
        data?.country?.name
      );
    }

    const city = data?.city || "";
    const street = data?.shippingaddress || "";
    const formattedAddress = street.includes(city) ? street : `${street}${street && city ? ", " : ""}${city}`;

    formik.setFieldValue("shippingAddress", formattedAddress);
    formik.setFieldValue("city", data?.city);
    formik.setFieldValue("state", stateAbbreviation);
    formik.setFieldValue("country", data?.country?.label);
    formik.setFieldValue("postalCode", data?.zipcode);

    const toAddress = {
      postalCode: data?.zipcode,
      state: stateAbbreviation,
      city: data?.city,
      country: data?.country?.sortname,
    };

    if (activeTab !== "sellUs") {
      shipStationRates(toAddress, formattedAddress);
    }
  };

  // const parseShippingAddress = (address) => {
  //   console.log("address", address);
  //   // Assuming the address format is "street, city, state, postalCode"
  //   const parts = address.split(", ");
  //   // if (parts.length === 4) {
  //   return {
  //     street: parts[0],
  //     city: parts[1],
  //     state: parts[2],
  //     postalCode: parts[3],
  //     country: parts[parts?.length - 1],
  //   };
  //   // }
  //   // return null;
  // };

  const handleQuantityChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, ""); // Remove all non-digit characters
    // Strip leading zeros (e.g. "007" → "7"), but keep empty string as-is
    const value = raw === "" ? "" : String(parseInt(raw, 10));
    formik.setFieldValue("quantity", value);
  };

  return (
    <>
      <div className={styles.buy_module}>
        <Form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <div className={`${styles.buy_module_asset} ${styles.mb_20}`}>
            <div className={styles.buy_module_asset_header}>
              <h6 className={styles.select_asset}>Select Asset</h6>
              <h6 className={styles.balance}>
                Bal:{" "}
                <span>
                  {Number(localTokenBalance) ? toFix(Number(localTokenBalance), 3) : "0"}{" "}
                  ozt
                </span>
              </h6>
            </div>

            <Select
              options={assetOptions}
              variant=" large_height"
              isSearchable={false}
              value={tokenSymbol}
              onChange={(selected) => {
                formik?.setFieldValue("tokenId", selected?.value);
                setTokenSymbol(selected);
              }}
            />
          </div>
          <div className={`${styles.qty} ${styles.mb_20}`}>
            <InputFormik
              id="quantity"
              name="quantity"
              label="Quantity"
              className={styles.qty_input}
              variant="large_height"
              placeholder="100.00"
              formik={formik}
              onChange={handleQuantityChange}
              onBlur={formik.handleBlur}
              // value={formik?.values?.quantity}
              value={formik.values.quantity}
              icon={<span className={styles.unit_suffix}>ozt</span>}
              maxLength={14}
            />
          </div>
          <div className={`${styles.address} ${styles.mb_20}`}>
            <InputFormik
              name="shippingAddress"
              label="Delivery Address"
              multiline={true}
              rows={2}
              variant="large_height"
              className={styles.address_input}
              placeholder="Please enter a valid shipping address."
              formik={formik}
              onBlur={formik.handleBlur}
              value={formik?.values?.shippingAddress}
              icon={<LocationIcon />}
              onClick={() => setShow(true)}
            />
          </div>
          <div className={`${styles.total_text} ${styles.mb_10}`}>
            <h6>Market Price</h6>
            <h4>{spotPrice ? `$ ${formatPrice(Number(spotPrice))}` : "---"}</h4>
          </div>
          {formik.errors.price && (
            <ErrorText className={styles.mb_10}>{formik.errors.price}</ErrorText>
          )}
          <div className={`${styles.total_text} ${styles.mb_20}`}>
            <h6>Delivery Costs</h6>
            <h4>$ {formatPrice(Number(shippingFee))}</h4>
          </div>
          <Button
            type="button"
            fluid
            disabled={!formik.isValid}
            onClick={(e) => {
              formik.handleSubmit(e);
            }}
          >
            Continue
          </Button>
        </Form>
      </div>
      <AddAddress
        show={show}
        handleClose={() => setShow(false)}
        address={address}
        setAddress={setAddress}
        saveAddress={(data) => handleAddress(data)}
      />
      <RedeemMakePayment
        show={showRedeemPayment}
        shippingFee={shippingFee}
        handleClose={() => setShowRedeemPayment(false)}
        address={address}
        redeemData={redeemData}
        resetForm={() => formik.resetForm()}
        shippedFee={shippedFee}
      />
    </>
  );
};

export default Redeem;